import * as z from 'zod'

export const siteAuditDocumentsReportFilterParamsSchema = z.object({
  frequency: z.string().optional().nullable(),
  licenseNumber: z.string().optional(),
  page: z.number().int().positive().default(1),
  relationshipId: z.number().optional().nullable(),
  size: z.number().int().positive().default(20),
  sortBy: z.string().optional().nullable().default('relationshipName'),
  sortDesc: z.boolean().optional().nullable().default(false)
})

export type SiteAuditDocumentsReportFilterParams = z.infer<typeof siteAuditDocumentsReportFilterParamsSchema>
